module.exports = __webpack_public_path__ + "static/media/aSkull.d021ad54.png";